// extracted by mini-css-extract-plugin
module.exports = {"productForm":"product-form_productForm__gjafy","deleteButton":"product-form_deleteButton__14U1T","coursePreview":"product-form_coursePreview__MWuR9"};